var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-API_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "API_Normal",
    clipPath: "url(#clip-API_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "APIs",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_31",
    "data-name": "Subtraction 31",
    d: "M-647.649-573.254h0a.565.565,0,0,1-.565-.537l-.17-2.414a12,12,0,0,1-3.395-1.412l-1.84,1.581a.546.546,0,0,1-.367.141.592.592,0,0,1-.41-.169l-2.83-2.852a.569.569,0,0,1-.029-.777l1.6-1.835a11.51,11.51,0,0,1-1.4-3.388l-2.419-.184a.571.571,0,0,1-.523-.565v-4.01a.6.6,0,0,1,.552-.564l2.419-.17a11.949,11.949,0,0,1,1.415-3.388l-1.585-1.835a.57.57,0,0,1,.029-.777l2.857-2.823a.559.559,0,0,1,.4-.169.523.523,0,0,1,.368.14l1.839,1.6a11.58,11.58,0,0,1,3.4-1.4l.184-2.414a.571.571,0,0,1,.566-.523l4.018.014a.562.562,0,0,1,.565.536l.17,2.414a12.025,12.025,0,0,1,3.4,1.412l1.839-1.581a.546.546,0,0,1,.368-.141.593.593,0,0,1,.41.17l2.83,2.838a.57.57,0,0,1,.028.777l-1.6,1.835a11.485,11.485,0,0,1,1.4,3.389l2.419.184a.569.569,0,0,1,.524.564v4.01a.593.593,0,0,1-.552.565l-2.419.169a11.952,11.952,0,0,1-1.415,3.388l1.584,1.835a.57.57,0,0,1-.028.777l-2.844,2.824a.563.563,0,0,1-.4.169.52.52,0,0,1-.368-.141l-1.839-1.6a11.505,11.505,0,0,1-3.41,1.4l-.184,2.414a.57.57,0,0,1-.566.522l-4.018-.013v.014Zm2.094-21.974a7.615,7.615,0,0,0-5.391,2.21,7.514,7.514,0,0,0-2.255,5.377,7.62,7.62,0,0,0,2.21,5.392,7.513,7.513,0,0,0,5.377,2.254,7.622,7.622,0,0,0,5.392-2.21,7.517,7.517,0,0,0,2.255-5.378,7.615,7.615,0,0,0-2.21-5.391A7.511,7.511,0,0,0-645.555-595.228Z",
    transform: "translate(660.598 602.597)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4570",
    "data-name": "Path 4570",
    d: "M18.467,6.556h4.026l.2,2.873a11.193,11.193,0,0,1,3.984,1.67l2.169-1.868,2.835,2.844L29.8,14.226a11.021,11.021,0,0,1,1.645,3.991l2.85.212v4.019l-2.878.2a11.15,11.15,0,0,1-1.673,3.976l1.871,2.165L30.178,30.2l-1.432,1.415-2.155-1.882a11.064,11.064,0,0,1-4,1.642l-.213,2.844H18.354l-.2-2.873a11.193,11.193,0,0,1-3.984-1.67L12,31.547,9.167,28.688l1.886-2.151a11.021,11.021,0,0,1-1.645-3.991l-2.85-.212V18.316l2.878-.2a11.15,11.15,0,0,1,1.673-3.976L9.238,11.976,12.1,9.146l2.155,1.882a11.064,11.064,0,0,1,4-1.642l.213-2.844m0-1.132a1.132,1.132,0,0,0-1.134,1.061l-.156,2.009A12.721,12.721,0,0,0,14.37,9.627L12.839,8.3a1.154,1.154,0,0,0-.751-.283,1.174,1.174,0,0,0-.808.325l-2.864,2.83a1.137,1.137,0,0,0-.057,1.557l1.318,1.528A12.378,12.378,0,0,0,8.5,17.042l-2.027.142A1.143,1.143,0,0,0,5.41,18.316v4.019a1.13,1.13,0,0,0,1.035,1.146l2.013.156a12.67,12.67,0,0,0,1.148,2.8L8.274,27.967a1.137,1.137,0,0,0,.057,1.557l2.835,2.858a1.128,1.128,0,0,0,.808.34,1.167,1.167,0,0,0,.751-.269l1.531-1.316a12.425,12.425,0,0,0,2.793,1.175l.142,2.024A1.143,1.143,0,0,0,18.326,35.4h4.026v.014a1.132,1.132,0,0,0,1.134-1.061l.156-2.009a12.721,12.721,0,0,0,2.807-1.146l1.531,1.33a1.154,1.154,0,0,0,.751.283,1.174,1.174,0,0,0,.808-.325l1.432-1.415L32.4,29.651a1.137,1.137,0,0,0,.057-1.557l-1.319-1.528a12.378,12.378,0,0,0,1.177-2.788l2.027-.142A1.143,1.143,0,0,0,35.409,22.5V18.485a1.13,1.13,0,0,0-1.035-1.146l-2.013-.156a12.669,12.669,0,0,0-1.148-2.8l1.333-1.528a1.137,1.137,0,0,0-.057-1.557L29.653,8.452a1.128,1.128,0,0,0-.808-.34,1.167,1.167,0,0,0-.751.269L26.563,9.7A12.426,12.426,0,0,0,23.77,8.523L23.628,6.5a1.143,1.143,0,0,0-1.134-1.061H18.467V5.424h0Z",
    transform: "translate(-5.41 -5.41)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(6.799 6.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    d: "M18.714,26.929h-.03a8.064,8.064,0,0,1-5.795-2.434,8.23,8.23,0,0,1-2.39-5.81,8.064,8.064,0,0,1,2.434-5.795,8.16,8.16,0,0,1,5.78-2.39h.03a8.064,8.064,0,0,1,5.795,2.434,8.23,8.23,0,0,1,2.39,5.81,8.064,8.064,0,0,1-2.434,5.795h0a8.16,8.16,0,0,1-5.78,2.39Zm0-15.219a7,7,0,0,0-.045,14.009h.03a7,7,0,0,0,.045-14.009h-.03Zm5.362,12.411Z",
    transform: "translate(-10.5 -10.5)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(9.798 11.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    d: "M13.69,18.017l-.134,1.269H12.51l.747-5.317H14.78l.777,5.317H14.5l-.149-1.269H13.69Zm.582-.9c-.075-.672-.179-1.718-.224-2.225H14c-.015.373-.149,1.568-.209,2.225h.493Z",
    transform: "translate(-12.51 -13.97)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    d: "M14.82,13.97h1.359c.881,0,1.329.463,1.329,1.4V15.7c0,.926-.344,1.494-1.359,1.494h-.3v2.091H14.835V13.97Zm1.031,2.39h.164c.388,0,.463-.224.463-.657v-.373c0-.344-.075-.568-.418-.568h-.209Z",
    transform: "translate(-11.37 -13.97)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4575",
    "data-name": "Path 4575",
    d: "M17.936,13.97v5.317H16.92V13.97h1.016Z",
    transform: "translate(-10.334 -13.97)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4576",
    "data-name": "Path 4576",
    d: "M18.856,17.572v.194c0,.224.045.418.269.418.149,0,.224-.09.224-.314s-.06-.388-.553-.7c-.627-.388-.881-.687-.881-1.3a1.068,1.068,0,0,1,1.195-1.18c.941,0,1.195.523,1.195,1.225v.179h-.941V15.84c0-.269-.075-.358-.224-.358s-.209.1-.209.3.075.3.448.523c.777.478,1,.807,1,1.449a1.106,1.106,0,0,1-1.269,1.269c-1.075,0-1.24-.657-1.24-1.269v-.164h.986Z",
    transform: "translate(-9.865 -13.615)",
    fill: "#6f8b8f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiNormal);
export default __webpack_public_path__ + "static/media/API_Normal.5ba64249b1a2c16ba82dcb8f94d0d39a.svg";
export { ForwardRef as ReactComponent };